/**
 *
 * Checkbox
 *
 */

import React from 'react';
import './style.less';
import { Checkbox as CustomCheckbox } from 'antd';

function Checkbox({ ...rest }: any) {
  return <CustomCheckbox {...rest} />;
}

export default Checkbox;
